<template>
	<div class="d-flex justify-content-center flex-wrap">
		<v-hover v-for="(file, i) in files" :key="i" v-slot:default="{ hover }">
			<v-card :elevation="hover ? 4 : 2" class="mr-4 mb-4" max-width="300">
				<v-btn
					v-show="hover"
					absolute
					fab
					x-small
					top
					right
					@click="removeFile(i)"
					:style="{ right: '-16px !important' }"
					class="elevation-4"
				>
					<v-icon>close</v-icon>
				</v-btn>

				<v-list-item three-line>
					<v-list-item-content>
						<div class="overline mb-4">File</div>
						<v-list-item-title class="mb-2">{{ file.name }}</v-list-item-title>
						<v-list-item-subtitle>{{ getFileSizeInMB(file.size) }}</v-list-item-subtitle>
					</v-list-item-content>

					<v-icon tile size="64">file_copy</v-icon>
				</v-list-item>
			</v-card>
		</v-hover>
		<label v-if="showAddIcon" class="d-flex pl-4">
			<v-icon tile size="64">add_to_photos</v-icon>
			<input
				hidden
				:multiple="multiple"
				type="file"
				accept="audio/*, video/*, image/*, zip/*, application/*"
				@change="onFileChange"
				ref="input"
			/>
		</label>
	</div>
</template>

<script>
export default {
	name: "MediaPreview",
	props: {
		multiple: {
			default: false
		},
		maxFileSize: {
			default: 20 * 1024 * 1024 // 20 mb
		}
	},
	data() {
		return {
			files: []
		};
	},
	methods: {
		getFileSizeInMB(byte) {
			return `${Number(byte / (1024 * 1024)).toFixed(2)} MB`;
		},
		onFileChange(e) {
			if (this.maxFileSize) {
				const files = Array.from(e.target.files).reduce(
					(acc, file) => {
						if (file.size >= this.maxFileSize) {
							return {
								...acc,
								greaterThanMaxFileSize: [file, ...acc.greaterThanMaxFileSize]
							};
						} else {
							return {
								...acc,
								lessThanMaxFileSize: [file, ...acc.lessThanMaxFileSize]
							};
						}
					},
					{
						greaterThanMaxFileSize: [],
						lessThanMaxFileSize: []
					}
				);
				if (files.greaterThanMaxFileSize.length) {
					this.$store.dispatch("SHOW_ALERT", {
						text: `${files.greaterThanMaxFileSize
							.map(file => file.name)
							.join(", ")} have file size greater than 20mb`
					});
				}
				if (files.lessThanMaxFileSize.length) {
					this.files = [...files.lessThanMaxFileSize, ...this.files];
				}
			} else {
				this.files = [...Array.from(e.target.files), ...this.files];
			}

			this.$refs.input.value = "";
		},
		removeFile(index) {
			this.files.splice(index, 1);
		}
	},
	computed: {
		showAddIcon() {
			if (this.multiple) {
				return true;
			}
			if (this.files.length === 1) {
				return false;
			}
			return true;
		}
	},
	watch: {
		files(newVal) {
			this.$emit("change", newVal);
		}
	}
};
</script>

<style lang="scss" scoped></style>
